// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface BlobServicesListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface BlobServicesSetServicePropertiesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface BlobServicesGetServicePropertiesOptionalParams extends OperationOptions {}
